import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import mapReducer from '../components/Map/reducers/MapReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
});

export default rootReducer;
